module.exports = __webpack_public_path__ + "img/cloud.be5030ca.webp";